/**
 * Ordering + Razorpay configuration for the online menu.
 *
 * Order creation and signature verification are handled by the gottea-api
 * backend (see routes/payments.js), so the client never ships secret keys.
 *
 * Optional env overrides (in `.env` for the CRA app):
 *   REACT_APP_API_BASE_URL=https://your-api-host
 *   REACT_APP_RAZORPAY_BRAND_NAME="Got Tea"
 *   REACT_APP_RAZORPAY_BRAND_COLOR="#46918A"
 *   REACT_APP_VISIT_REWARD_POPUP=false          (kill-switch for the visit reward popup)
 *   REACT_APP_APP_DOWNLOAD_URL=https://...      (where the popup's app button goes)
 */

const env = (typeof process !== "undefined" && process.env) || {};

/**
 * Base URL of the gottea-api backend (DigitalOcean App Platform).
 * Override locally with REACT_APP_API_BASE_URL.
 */
export const API_BASE_URL =
  env.REACT_APP_API_BASE_URL ||
  "https://gottea-search-5gtrn.ondigitalocean.app";

export const RAZORPAY_CONFIG = {
  // Branding shown inside the Razorpay checkout modal. The actual key id and
  // razorpay order id are returned by the backend's /payments/order endpoint.
  brandName: env.REACT_APP_RAZORPAY_BRAND_NAME || "Got Tea",
  brandColor: env.REACT_APP_RAZORPAY_BRAND_COLOR || "#46918A",
};

// Default currency for the store.
export const PAYMENT_CURRENCY = "INR";

/**
 * Visit reward popup shown on the order confirmation (visits 1-4). On by
 * default; set REACT_APP_VISIT_REWARD_POPUP=false to switch it off.
 */
export const VISIT_REWARD_POPUP_ENABLED =
  String(env.REACT_APP_VISIT_REWARD_POPUP || "").toLowerCase() !== "false";

/** Destination of the popup's "Download the app" button. */
export const APP_DOWNLOAD_URL =
  env.REACT_APP_APP_DOWNLOAD_URL || "https://gottea.in/app";
